import Cookies from 'universal-cookie';

export const createClientCookies = () => new Cookies();
